import { extendTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import * as React from "react";
import { useLocationConfiguration } from "./LocationConfiguration";
import { getMUILocale } from "@tlc/ui/localization/getMUILocale";

interface LS2ThemeProviderProps extends React.PropsWithChildren {
  isKids: boolean;
}

export const autofillOverride = {
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        "&:-webkit-autofill": {
          boxShadow: `0 0 0 100px #E8F0FE inset`,
          WebkitTextFillColor: "var(--mui-palette-text-primary)",
        },
      },
    },
  },
  MuiRating: {
    styleOverrides: {
      visuallyHidden: {
        color: "#000000",
      },
    },
  },
};

export const LS2ThemeProvider = ({
  children,
  isKids,
}: LS2ThemeProviderProps) => {
  const { locationConfiguration } = useLocationConfiguration();
  const { primaryColor, secondaryColor } =
    locationConfiguration.pacSettings.displaySettings;

  const LS2PACTheme = React.useMemo(() => {
    return extendTheme(
      {
        colorSchemes: {
          light: {
            palette: {
              primary: {
                main: primaryColor,
              },
              secondary: {
                main: secondaryColor,
              },
              info: {
                main: "#027ABB",
              },
              contrastThreshold: 4.5,
            },
          },
        },
        typography: {
          button: {
            textTransform: "capitalize",
          },
        },
        components: {
          ...autofillOverride,
        },
      },
      getMUILocale(),
    );
  }, [primaryColor, secondaryColor]);

  const theme = isKids ? LS2KidsTheme : LS2PACTheme;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export const PreviewThemeProvider = ({ children }: LS2ThemeProviderProps) => {
  const { locationConfiguration } = useLocationConfiguration();
  const { primaryColor, secondaryColor } =
    locationConfiguration.pacSettings.displaySettings;
  console.log(
    "PreviewThemeProvider theme updated: %s %s",
    primaryColor,
    secondaryColor,
  );

  const LS2PacTheme = React.useMemo(() => {
    return extendTheme(
      {
        cssVarPrefix: "md-demo",
        colorSchemes: {
          light: {
            palette: {
              primary: {
                main: primaryColor,
              },
              secondary: {
                main: secondaryColor,
              },
              contrastThreshold: 4.5,
            },
          },
        },
        typography: {
          button: {
            textTransform: "capitalize",
          },
        },
      },
      getMUILocale(),
    );
  }, [primaryColor, secondaryColor]);

  return <ThemeProvider theme={LS2PacTheme}>{children}</ThemeProvider>;
};

export const LS2KidsTheme = extendTheme(
  {
    colorSchemes: {
      light: {
        palette: {
          contrastThreshold: 4.5,
          primary: {
            main: "#0071bc",
          },
        },
      },
    },

    typography: {
      button: {
        textTransform: "none",
        fontFamily: "taffyregular",
        fontSize: "1.5rem",
      },
    },

    components: {
      ...autofillOverride,
    },
  },
  getMUILocale(),
);
